import { Trans } from '@lingui/react';
import LogoutIcon from '@mui/icons-material/Logout';
import { ListItemDecorator } from '@startuptools/ui/ListItemDecorator';
import { MenuItem } from '@startuptools/ui/MenuItem';

export const LogoutMenuItem = ({ onClick }: { onClick: () => void | Promise<void> }) => {
  return (
    <MenuItem onClick={onClick}>
      <ListItemDecorator>
        <LogoutIcon />
      </ListItemDecorator>
      <Trans id="Logout" />
    </MenuItem>
  );
};
